import React from "react";
import { Helmet } from "react-helmet";
import { helmetJsonLdProp } from "react-schemaorg";
import { site_SEO_META } from "../../constants/app-constants";
import logo from "../../assets/images/logo-myhealthcare.svg";
import thumbnail from "../../assets/images/thumbnail";
import { useState } from "react";
import { useEffect } from "react";

const Helmet_SEO_META = ({ SEO_META, HomeCareCategory, HomeCareService }) => {

  

    const [homecareIndex, setHomecareIndex] = useState(null);
    
    
    // console.log("window.location.contains", window.location.href,  window.location.href.includes("book-consult/hospitals"))
    const sitename = 'MyHealthcare';
    const commonSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": sitename,
        "alternateName": "MyHealthcare",
        "url": SEO_META.pageURL,
        "logo": logo,
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "011-41198700",
            "contactType": "customer service",
            "email": "support@myhealthcare.life, assist@myhealthcare.life",
            "areaServed": "IN",
            "availableLanguage": ["en", "Hindi"]
        },
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "MyHealthcare Technologies Pvt Ltd, The Circle.Work, HUDA City Centre, 5th Floor, Sector 29",
            "addressLocality": "Gurugram",
            "addressRegion": "Haryana",
            "postalCode": "122002",
            "addressCountry": "India"
        },
        "sameAs": [
            "https://www.facebook.com/MyHealthcareEcosystem/",
            "https://twitter.com/MyHLTHcare",
            "https://www.instagram.com/myhealthcare.life/",
            "https://www.linkedin.com/company/ivpl/",
            "https://www.myhealthcare.co/"
        ]
    }

    const HomecareProvider = "Housepital, Max@Home, Portea, HCAH";
    
  useEffect(() => {
    if (HomeCareCategory){
        let getCat = HomeCareCategory?.map((item) => {
            return (
            {
                "@type": "Offer",
                "itemOffered": {
                    "@type": "Service",
                    "name": item.name,
                    "provider": HomecareProvider,
                    "isRelatedTo": {
                        "@type": "Service",
                        "name": SEO_META.keywords,
                        "description": SEO_META.description
                    }
                }
            }
            )
        })
    
        setHomecareIndex(getCat);
    } else{
        let getCat =  {
                "@type": "Offer",
                "itemOffered": {
                    "@type": "Service",
                    "name": HomeCareService?.toUpperCase(),
                    "provider": HomecareProvider,
                    "isRelatedTo": {
                        "@type": "Service",
                        "name": SEO_META.keywords,
                        "description": SEO_META.description
                    }
                }
            }    
        setHomecareIndex(getCat);
    }
  }, [HomeCareCategory]);





    return (
        <>
            {site_SEO_META === true ?
                <>
                    <Helmet
                        title={SEO_META.title}
                        meta={[
                            {
                                name: 'description',
                                content: SEO_META.description,
                            },
                            {
                                name: 'keywords',
                                content: SEO_META.keywords,
                            },
                            {
                                name: 'robots',
                                content: "index, follow",
                            },
                            {
                                property: 'canonical',
                                content: SEO_META.pageURL
                            },
                            {
                                property: 'og:locale',
                                content: 'en_US'
                            },
                            {
                                property: 'og:type',
                                content: 'article'
                            },
                            {
                                property: 'og:image',
                                content: thumbnail
                            },
                            {
                                property: 'og:title',
                                content: SEO_META.title
                            },
                            {
                                property: 'og:description',
                                content: SEO_META.description
                            },
                            {
                                property: 'og:keywords',
                                content: SEO_META.keywords
                            },
                            {
                                property: 'og:url',
                                content: SEO_META.pageURL
                            },
                            {
                                property: 'og:site_name',
                                content: sitename
                            },
                            {
                                property: 'twitter:card',
                                content: SEO_META.description
                            },
                            {
                                property: 'twitter:url',
                                content: SEO_META.pageURL
                            },
                            {
                                property: 'twitter:title',
                                content: SEO_META.title
                            },
                            {
                                property: 'twitter:description',
                                content: SEO_META.description
                            },
                            {
                                property: 'twitter:image',
                                content: thumbnail
                            }
                        ]}
                    >
                    </Helmet>
                    <Helmet
                        script={[
                            helmetJsonLdProp([
                                commonSchema,
                    
                            ])
                        ]}
                        >
                    </Helmet>

                    {
                        // Schema For Hospitals, Specialities,  Clinics, Doctors
                        window.location.href.includes("book-consult/hospitals") ?
                            <Helmet
                                script={[
                                    helmetJsonLdProp([
                                        // commonSchema,
                                        {
                                            "@context": "https://schema.org/",
                                            "@type": "Service",
                                            "serviceType": "Doctor Consult",
                                            "description": SEO_META.description,
                                            "hasOfferCatalog": {
                                                "@type": "OfferCatalog",
                                                "name": "Doctor Consult",
                                                "itemListElement": [
                                                    {
                                                        "@type": "OfferCatalog",
                                                        "name": "At Hospital Consult",
                                                        "itemListElement": [
                                                            {
                                                                "@type": "Offer",
                                                                "itemOffered": {
                                                                    "@type": "Service",
                                                                    "name": "Virtual / Video Consult"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        }
                                    ])
                                ]}
                            >
                            </Helmet>

                            // For Diagnostics Schema
                            : window.location.href.includes("book-package-or-test") ?
                                <Helmet
                                    script={[
                                        helmetJsonLdProp([
                                            // commonSchema,
                                            {
                                                "@context": "https://schema.org/",
                                                "@type": "Service",
                                                "serviceType": "Lab Tests",
                                                "description": SEO_META.description,
                                                "hasOfferCatalog": {
                                                    "@type": "OfferCatalog",
                                                    "name": "Diagnostics Packages",
                                                    "itemListElement": [
                                                        {
                                                            "@type": "OfferCatalog",
                                                            "name": "Diagnostics Test",
                                                            "itemListElement": [
                                                                {
                                                                    "@type": "Offer",
                                                                    "itemOffered": {
                                                                        "@type": "Service",
                                                                        "name": "Home Sample Collection"
                                                                    }
                                                                },
                                                                {
                                                                    "@type": "Offer",
                                                                    "itemOffered": {
                                                                        "@type": "Service",
                                                                        "name": "Blood and Urine Tests"
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            }
                                        ])
                                    ]}
                                >
                                </Helmet>

                                // For HomeCare Schema
                                : window.location.href.includes("homecare-services") || window.location.href.includes("homecare-service-packages") ?
                                    <Helmet
                                        script={[
                                            helmetJsonLdProp([
                                                // commonSchema,
                                                {
                                                    "@context": "https://schema.org/",
                                                    "@type": "Service",
                                                    "serviceType": "Homecare Services",
                                                    "description": SEO_META.description,
                                                    "areaServed": {
                                                        "@type": "AdministrativeArea",
                                                        "name": "Delhi NCR , Mumbai, Bengaluru, Kolkatta, Chennai, Hyderabad"
                                                    },
                                                    "provider": {
                                                        "@type": "Organization",
                                                        "name": HomecareProvider,
                                                    },
                                                    "hasOfferCatalog": {
                                                        "@type": "OfferCatalog",
                                                        "name": "Healthcare Services at Home",
                                                        "itemListElement":homecareIndex
                                                    }

                                                },
                                            ])
                                        ]}
                                    >
                                    </Helmet>
                                    :
                                    // For Common Schema Home, About us, Contact us...
                                    // <Helmet
                                    //     script={[
                                    //         helmetJsonLdProp([
                                    //             commonSchema,
                                    //         ])
                                    //     ]}
                                    // >
                                    // </Helmet>
                                    null
                    }
                </>
                :
                <Helmet>
                    <meta name="robots" content="noindex, nofollow" />
                </Helmet>
            }
        </>
    )
}
export default Helmet_SEO_META